import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseUrls } from '@app/app.constants';
import { Presence } from '@app/core/interfaces/c5/presence';
import { RichPresenceDef } from '@app/core/interfaces/c5/rich-presence-def';
import { PresenceInformationUpdate } from '@app/core/interfaces/portal/presence-information-update';
import { UserLevel } from '@app/core/models/user-level';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RichPresenceStateRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  get(): Observable<Presence> {
    return this.apiUrl('/presence').pipe(
      mergeMap((url) => this.http.get<Presence>(url)),
      wrapError('rich-presence:get')
    );
  }

  listAvailablePresenceStates(): Observable<RichPresenceDef[]> {
    return this.apiUrl('/richPresenceDefinitions').pipe(
      mergeMap((url) => this.http.get<RichPresenceDef[]>(url)),
      wrapError('rich-presence:list-states')
    );
  }

  listEnterpriseDefinitions(): Observable<RichPresenceDef[]> {
    return this.utils.apiUrl('/richPresenceDefinitions').pipe(
      mergeMap((url) => this.http.get<RichPresenceDef[]>(url)),
      wrapError('rich-presence:list-enterprise-definitions')
    );
  }

  update(activity: Partial<Presence>): Observable<void> {
    return this.apiUrl('/presence').pipe(
      mergeMap((url) => this.http.put<void>(url, activity)),
      wrapError('rich-presence:update')
    );
  }

  updatePresenceInformation(update: PresenceInformationUpdate): Observable<RichPresenceDef[]> {
    return this.utils.apiUrl('/richPresenceDefinitions').pipe(
      mergeMap((url) => this.http.put<RichPresenceDef[]>(url, update)),
      wrapError('rich-presence:list-enterprise-definitions')
    );
  }

  private apiUrl(url: string): Observable<string> {
    return this.utils.apiUrl({
      [UserLevel.ServiceProviderAdmin]: `${BaseUrls.ServiceProvider.EndUser}${url}`,
      [UserLevel.EnterpriseAdmin]: `${BaseUrls.Enterprise.EndUser}${url}`,
      [UserLevel.EndUser]: `/user${url}`,
    });
  }
}
